"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactCookies = _interopRequireDefault(require("react-cookies"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TooltipWrapper = _styledComponents["default"].div.withConfig({
  displayName: "citySelection__TooltipWrapper",
  componentId: "sc-8ocvlp-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: ", ";\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    background: rgba(255,255,255,1);\n    border: 1px solid #ebebeb;\n    box-shadow: 0 5px 10px rgba(0, 0, 0, .21);\n    box-sizing: border-box;\n    border-radius: 4px;\n    padding: 25px 40px;\n    position: absolute;\n    top: 56px;\n    left: 0;\n    z-index: 5;\n    width: 658px;\n    @media (max-width: 690px) {\n        flex-direction: column;\n        align-items: flex-start;\n        width: auto;\n    }\n"])), function (props) {
  return props.show ? 'flex' : 'none';
});

var Content = _styledComponents["default"].div.withConfig({
  displayName: "citySelection__Content",
  componentId: "sc-8ocvlp-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n"])));

var TooltipTitle = _styledComponents["default"].div.withConfig({
  displayName: "citySelection__TooltipTitle",
  componentId: "sc-8ocvlp-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    font-family: 'Roboto Regular', Arial, Helvetica, sans-serif;\n    font-size: 16px;\n    line-height: 18px;\n    color: #979797;\n    margin-bottom: 5px;\n"])));

var TooltipCity = _styledComponents["default"].div.withConfig({
  displayName: "citySelection__TooltipCity",
  componentId: "sc-8ocvlp-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-family: 'Roboto Regular', Arial, Helvetica, sans-serif;\n    font-size: 20px;\n    line-height: 28px;\n    color: #000;\n    @media (max-width: 690px) {\n        margin-bottom: 20px;\n    }\n"])));

var TooltipFooter = _styledComponents["default"].div.withConfig({
  displayName: "citySelection__TooltipFooter",
  componentId: "sc-8ocvlp-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: nowrap;\n    @media (max-width: 690px) {\n        justify-content: flex-start;\n    }\n    @media (max-width: 500px) {\n        flex-direction: column;\n        width: 100%;\n    }\n"])));

var TooltipButton = _styledComponents["default"].button.withConfig({
  displayName: "citySelection__TooltipButton",
  componentId: "sc-8ocvlp-5"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: inline-block;\n    background:", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n    color: #1a1a1a;\n    cursor: pointer;\n    font-family: 'Roboto Regular', Arial, Helvetica, sans-serif;\n    font-size: 16px;\n    line-height: 46px;\n    padding: 0 18px;\n    height: 48px;\n    text-align: center;\n    width: 159px;\n    white-space: nowrap;\n    margin-left: ", ";\n\n    @media only screen and (max-width: 640px) {\n    padding: 0 14px;\n    }\n\n    @media only screen and (max-width: 350px) {\n    padding: 0 12px;\n    }\n    @media (max-width: 500px) {\n        width: 100%;\n        margin: 0;\n        &:first-child {\n            margin-bottom: 15px;\n        }\n    }\n"])), function (props) {
  return props.transparentBtn ? 'transparent' : '#ffd400';
}, function (props) {
  return props.transparentBtn ? '#cecece' : '#ffd400';
}, function (props) {
  return props.offsetBtn ? '0' : '15px';
});

var CitySelection = /*#__PURE__*/function (_Component) {
  _inherits(CitySelection, _Component);

  var _super = _createSuper(CitySelection);

  function CitySelection() {
    var _this;

    _classCallCheck(this, CitySelection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      show: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      var expires = new Date();
      expires.setDate(expires.getDate() + 41);

      _reactCookies["default"].save('cityconfirm', 1, {
        expires: expires,
        domain: _this.props.cookieDomain,
        path: '/'
      });

      _this.setState({
        show: false
      }, function () {
        _this.props.onClose();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "noBtnClick", function () {
      _this.setState({
        show: false
      }, function () {
        return _this.props.onBackClick();
      });
    });

    return _this;
  }

  _createClass(CitySelection, [{
    key: "gaCityShow",
    value: function gaCityShow() {
      if (window && window.sessionStorage.getItem('GA') !== '1') {
        window.sessionStorage.setItem('GA', '1');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'category': 'City Choice',
          'action': 'Show',
          'event': 'UAevent'
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isAuth || !!_reactCookies["default"].load('cityconfirm')) {
        this.setState({
          show: false
        });
      } else {
        this.setState({
          show: true
        });
        this.gaCityShow();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var isAuth = _ref.isAuth;

      if (isAuth !== this.props.isAuth && this.props.isAuth) {
        this.setState({
          show: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$isOpen = _this$props.isOpen,
          isOpen = _this$props$isOpen === void 0 ? this.state.show : _this$props$isOpen,
          city = _this$props.city,
          className = _this$props.className;
      return /*#__PURE__*/_react["default"].createElement(TooltipWrapper, {
        className: className,
        show: isOpen
      }, /*#__PURE__*/_react["default"].createElement(Content, null, /*#__PURE__*/_react["default"].createElement(TooltipTitle, null, "\u0412\u0430\u0448 \u0433\u043E\u0440\u043E\u0434"), /*#__PURE__*/_react["default"].createElement(TooltipCity, null, city.name)), /*#__PURE__*/_react["default"].createElement(TooltipFooter, null, /*#__PURE__*/_react["default"].createElement(TooltipButton, {
        onClick: this.noBtnClick,
        transparentBtn: true,
        offsetBtn: true
      }, "\u041D\u0435\u0442, \u0434\u0440\u0443\u0433\u043E\u0439"), /*#__PURE__*/_react["default"].createElement(TooltipButton, {
        onClick: this.handleClick,
        className: "js__tooltip-city_close"
      }, "\u0414\u0430, \u0441\u043F\u0430\u0441\u0438\u0431\u043E")));
    }
  }]);

  return CitySelection;
}(_react.Component);

_defineProperty(CitySelection, "propTypes", {
  city: _propTypes["default"].object,
  cookieDomain: _propTypes["default"].string,
  isAuth: _propTypes["default"].bool,
  switchShowCitySelect: _propTypes["default"].func
});

_defineProperty(CitySelection, "defaultProps", {
  city: {},
  isAuth: false,
  onBackClick: function onBackClick() {},
  onClose: function onClose() {}
});

var _default = CitySelection;
exports["default"] = _default;